"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeInputPadding = function (_a) {
    var icon = _a.icon, reverse = _a.reverse;
    return function (_a) {
        var theme = _a.theme;
        var _b = theme.inputs.textInput, padding = _b.padding, iconPadding = _b.iconPadding;
        if (icon) {
            return reverse ?
                "padding: " + iconPadding[0] :
                "padding: " + iconPadding[1];
        }
        return "padding: " + padding[0] + " " + padding[1];
    };
};
exports.default = makeInputPadding;
